import React from 'react';
import IDVHeader from './../Common/IDVHeader';
import IDVButton from './../Common/IDVButton';
import IDVInfoButton from './../Common/IDVInfoButton';
import { IDV_HEADER, IDV_SUB_HEADER, IDV_INFO, IDV_SUB_HEADER_KBV } from './../Constants/labels';
import { submitKbv } from './../../../actions/crossSellApplicationActions';
import { connect } from 'react-redux';
import { addBankDetailsUrl } from './../Constants/urls';
import { Redirect } from 'react-router';
import { kbvDataLayer } from "./../../../analytics/adobe/dataLayerValues";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "./../../../analytics/adobe/index";
import './kbv.scss';

class Kbv extends React.Component {
  state = {
    showError: false,
    kbvQuestionsData: this.props.data!==null?this.props.data:null,
    kbvQuestions: this.props.data ? this.props.data.data.attributes.questions.map(field=> {
      return { ...field, ...{ val: '' } };
    }) : null,
    isContinueButtonDisable: true,
    cancelKbv: false,
    btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null
  };

  componentDidMount() {
    const { pageName, siteSection }=kbvDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  componentDidUpdate(prevProps, nextState){
    if(prevProps.data !== this.props.data && this.props.data!==null ){
      this.setState({
        btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null,
        kbvQuestionsData: this.props.data!==null?this.props.data:null,
        kbvQuestions: this.props.data ? this.props.data.data.attributes.questions.map(field=> {
          return { ...field, ...{ val: '' } };
        }) : null
      });
    }
  }

  getInputProps(type) {
    switch (type) {
    case 'CVV':
    {
      return {
        type: 'password',
        maxLength: '3'
      };
    }
    case 'MMN':
    {
      return {
        type: 'text',
        maxLength: '30'
      };
    }
    case 'SSN':
    {
      return {
        type: 'text',
        maxLength: '4'
      };
    }
    default:
    {
      return {
        type: 'text',
        maxLength: '30'
      };
    }
    }
  }

  handleInputChange(e, selectedIndex, type) {
    let inputValue = null;
    if (type === 'SSN' || type === 'CVV') {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        inputValue = e.target.value;
      }
    } else {
      inputValue = e.target.value;
    }

    if (inputValue !== null) {
      let temp = [...this.state.kbvQuestions];
      temp[selectedIndex].val = inputValue;
      let checkContinueBtnState = temp.every(v=>v.val.length > 0);

      this.setState({
        kbvQuestions: temp,
        isContinueButtonDisable: !checkContinueBtnState
      });
    }
  }

  handleContinueClick() {
    let kbvAnswers = this.state.kbvQuestions.map(que=> {
      return {
        questionId: que.questionId,
        answer: que.val
      };
    });
    const { data: { id } }=this.state.kbvQuestionsData;
    let formData = {
      clkbVsubmitAnswersRequest: {
        answers: kbvAnswers,
        questionSetID: id
      }
    };
    //Submit KBV Answers
    this.props.submitKbv(formData, this.props.bankInfo, this.props.challengeType);
  }

  render() {
    if (this.state.cancelKbv) {
      return <Redirect push to={addBankDetailsUrl} />;
    }
    const { kbvQuestions }=this.state;
    let checkDisableBtn = (this.props.disableContinueBtnPerm == "update_power_curve") || (this.props.disableContinueBtnPerm =="approved")?true:this.state.isContinueButtonDisable;
    return (
      <div className="row kbvPage">
        <div className="col-xs-12 col-lg-12 col-md-12">
          <div
            className={this.state.showError? 'errors-container show-block-error' : 'errors-container hide-block-error'}>
            <span className="clapply-icon exclamation-mark error-red error-exclamation-mark">&#9432;</span>
            <h5 className="congratulations header-font standard-blue select-delivery" role="alert">Errors found below.
              <span className="times-right-align">&times;</span></h5>
            <div className="congrats-text">
              <p className="standard-blue" role="alert">The answer you entered did not match our records. Please try again.</p>
            </div>
          </div>
          <div className="col-xs-12 col-lg-12 col-md-12">
            <IDVHeader subHeading={IDV_SUB_HEADER_KBV}/>
          </div>
          <div className="col-xs-12 col-lg-12 col-md-12">
            {
              kbvQuestions && kbvQuestions.map((item, index)=> {
                return <div key={`rsa-input-${index}`} className="idv-kbv-wrapper">
                  <div className="kbv-questions-wrapper">
                    <p className="standard-blue" aria-label={item.question} id={`kbvQuestion-${index}`}>{item.question}</p>
                    {
                      item.questionRef==='CVV'? <IDVInfoButton /> : null
                    }
                  </div>
                  <input className="idv-kbv-input standard-blue"
                    {...this.getInputProps(item.questionRef)}
                    value={item.val}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    onChange={e=>this.handleInputChange(e, index, item.questionRef)}
                    aria-labelledby={`kbvQuestion-${index}`}
                  />
                </div>;
              })
            }
          </div>
          <div className="col-sm-12 lg-12 xs-12">
            <div className="kbv-btns-wrapper">
              <IDVButton id="ContinueBtnKbv"
                title="Continue"
                track="custom-links"
                isButtonDisabled={checkDisableBtn}
                onBtnClick={e=>this.handleContinueClick()}
                ariaLabel="click to continue"/>
              <IDVButton id="CancelBtnKbv"
                title="Cancel"
                track="custom-links"
                toggleStyle={true}
                onBtnClick={e=>this.setState({ cancelKbv: true })}
                ariaLabel="click to cancel"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    disableContinueBtnPerm: state.creditCardApplicant.disableContinueBtnPerm
  };
};

const mapDispatchToProps = { submitKbv: submitKbv };

export default connect(mapStateToProps, mapDispatchToProps)(Kbv);
